// Because typescript sometimes is stoopid

export const TRUE: boolean = true;
export const FALSE: boolean = false;
